/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface SeedDataSetsWithJobsRequestDto
 */
export interface SeedDataSetsWithJobsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SeedDataSetsWithJobsRequestDto
     */
    jobConfigurationIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SeedDataSetsWithJobsRequestDto
     */
    $type?: SeedDataSetsWithJobsRequestDtoTypeEnum;
}


/**
 * @export
 */
export const SeedDataSetsWithJobsRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoSeedDataSetsWithJobsRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.SeedDataSetsWithJobsRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SeedDataSetsWithJobsRequestDtoTypeEnum = typeof SeedDataSetsWithJobsRequestDtoTypeEnum[keyof typeof SeedDataSetsWithJobsRequestDtoTypeEnum];


/**
 * Check if a given object implements the SeedDataSetsWithJobsRequestDto interface.
 */
export function instanceOfSeedDataSetsWithJobsRequestDto(value?: unknown): value is SeedDataSetsWithJobsRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SeedDataSetsWithJobsRequestDtoTypeEnum)[0];
}

export function SeedDataSetsWithJobsRequestDtoFromJSON(json: any): SeedDataSetsWithJobsRequestDto {
    return SeedDataSetsWithJobsRequestDtoFromJSONTyped(json, false);
}

export function SeedDataSetsWithJobsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeedDataSetsWithJobsRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobConfigurationIds': !exists(json, 'jobConfigurationIds') ? undefined : json['jobConfigurationIds'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function SeedDataSetsWithJobsRequestDtoToJSON(value?: SeedDataSetsWithJobsRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'jobConfigurationIds': value.jobConfigurationIds,
        '$type': value.$type,
    });
}

